import { render, staticRenderFns } from "./GroupTableMenu.vue?vue&type=template&id=3507cf08&scoped=true&"
import script from "./GroupTableMenu.vue?vue&type=script&lang=js&"
export * from "./GroupTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3507cf08",
  null
  
)

export default component.exports